export const account = {
  page_heading: "Customer Account",
  editor_label_name: "Name",
  editor_label_org_number: "Organization Number",
  editor_label_address_line1: "Address",
  editor_label_address_line2: "Address, line 2",
  editor_label_address_postal_code: "Postal Code",
  editor_label_address_region: "City",

  account_admin_heading: "Process Owner - Authorization 1",
  number_admins_assigned: "person(s)",
  account_admin_add_placeholder: "Add new, enter email address",
  error_conflict: "This user is already admin in other organisation.",
  error_conflict_connected:
    "This account is connected with the other organisation.",

  btn_homes: "View Homes",

  btn_regenerate_qr: "Generate new QR code",
};
